const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiInsightsRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ai-robotics-brain-technology-artificial_intelligence",
    "data-name": "Ai-robotics-brain-technology-artificial intelligence"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,41a4,4,0,0,0-4-4V35a5.986,5.986,0,0,1,5.63,3.96c.13.01.24.04.37.04a4,4,0,0,0,1.83-7.55A3.872,3.872,0,0,0,46,31V29a5.915,5.915,0,0,1,1.78.28,3.942,3.942,0,0,0-1.97-4.83A6,6,0,0,1,40,29V27a4,4,0,1,0-4-4V41a4,4,0,0,0,8,0Z",
    id: "id_101",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,19a4,4,0,0,0,0,8v2a6.006,6.006,0,0,1-5.815-4.547A4,4,0,0,0,16,28a3.909,3.909,0,0,0,.22,1.281A5.98,5.98,0,0,1,18,29v2a3.9,3.9,0,0,0-1.822.444A4,4,0,0,0,18,39c.133,0,.241-.03.365-.041A6,6,0,0,1,24,35v2a4,4,0,1,0,4,4V23A4,4,0,0,0,24,19Z",
    id: "id_102",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,14.54l2.55-1.71A1,1,0,0,0,43,12V8.82a3,3,0,1,0-2,0v2.64l-2.55,1.71A1,1,0,0,0,38,14v3.35L40,17Z",
    id: "id_103",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,8.82V12a1,1,0,0,0,.45.83L24,14.54V17a5.8,5.8,0,0,1,2,.35V14a1,1,0,0,0-.45-.83L23,11.46V8.82a3,3,0,1,0-2,0Z",
    id: "id_104",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,55.18V52a1,1,0,0,0-.45-.83L40,49.46V47a5.8,5.8,0,0,1-2-.35V50a1,1,0,0,0,.45.83L41,52.54v2.64a3,3,0,1,0,2,0Z",
    id: "id_105",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,49.46l-2.55,1.71A1,1,0,0,0,21,52v3.18a3,3,0,1,0,2,0V52.54l2.55-1.71A1,1,0,0,0,26,50V46.65A5.8,5.8,0,0,1,24,47Z",
    id: "id_106",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,35a3,3,0,0,0,2.82-2h3.53a5.489,5.489,0,0,1,1.19-2H8.82A3,3,0,1,0,6,35Z",
    id: "id_107",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,42a1,1,0,0,0-.83.45L11.46,45H8.82a3,3,0,1,0,0,2H12a1,1,0,0,0,.83-.45L14.54,44h4.27a5.511,5.511,0,0,1-.72-2Z",
    id: "id_108",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,21a3,3,0,0,0,2.82-2h2.64l1.71,2.55A1,1,0,0,0,14,22h4.09a5.511,5.511,0,0,1,.72-2H14.54l-1.71-2.55A1,1,0,0,0,12,17H8.82A3,3,0,1,0,6,21Z",
    id: "id_109",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,43a3,3,0,0,0-2.82,2H52.54l-1.71-2.55A1,1,0,0,0,50,42H45.91a5.511,5.511,0,0,1-.72,2h4.27l1.71,2.55A1,1,0,0,0,52,47h3.18A3,3,0,1,0,58,43Z",
    id: "id_110",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,29a3,3,0,0,0-2.82,2H50.46a5.489,5.489,0,0,1,1.19,2h3.53A3,3,0,1,0,58,29Z",
    id: "id_111",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,22a1,1,0,0,0,.83-.45L52.54,19h2.64a3,3,0,1,0,0-2H52a1,1,0,0,0-.83.45L49.46,20H45.19a5.511,5.511,0,0,1,.72,2Z",
    id: "id_112",
    style: {
      fill: "rgb(191, 29, 46)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiInsightsRed);
export default __webpack_public_path__ + "static/media/Ai_Insights_Red.74f510a87247a0014af93e87b9dcb657.svg";
export { ForwardRef as ReactComponent };